import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { CmxLayoutService } from '../../services/cmx-layout.service';
import { LegalEntityService } from '../../services/legal-entity.service';
import { MenuService } from '../../services/menu.service';
import { Direction } from '../../types/directions';

@Component({
  selector: 'cmx-layout',
  templateUrl: './cmx-layout.component.html',
  styleUrls: ['./cmx-layout.component.scss'],
  animations: [
    trigger('mobileMenu', [
      state('*', style({ left: '*' })),
      state('void', style({ left: '-100%' })),
      transition('void => *', animate('.2s ease-in-out')),
      transition('* => void', animate('.2s ease-in')),
    ]),
  ],
})
export class CmxLayoutComponent implements OnInit, OnDestroy {
  isMobile: boolean;
  isMobileMenuOpen: boolean;
  isMobileLangSelectorOpen: boolean;
  isMobileEntitySelectorOpen: boolean;
  isMobileAppSelectorOpen: boolean;
  direction: Direction;
  isCollapsed: boolean;
  loader: number;
  version: number;
  isModalOpen: boolean;

  private subsriptions: Subscription[] = [];

  @Input()
  public entityName: string = null;
  @Input()
  public entityId: string = null;
  @Input()
  public employeeVariant = false;

  constructor(
    private layout: CmxLayoutService,
    private menu: MenuService,
    public legalEntity: LegalEntityService,
  ) {}

  ngOnInit() {
    this.subsriptions.push(
      this.layout.isMobileMenuOpen.subscribe((value) => (this.isMobileMenuOpen = value)),
      this.layout.isMobile.subscribe((value) => {
        this.isMobile = value;
      }),
      this.layout.direction.subscribe((value) => {
        this.direction = value;
        const element = document.getElementsByTagName('body');
        element[0].setAttribute('dir', value);
      }),
      this.layout.isMobileEntitySelectorOpen.subscribe((value) => (this.isMobileEntitySelectorOpen = value)),
      this.layout.isMobileLangSelectorOpen.subscribe((value) => (this.isMobileLangSelectorOpen = value)),
      this.layout.loader.subscribe((value) => (this.loader = value)),
      this.layout.isMobileAppSelectorOpen.subscribe((value) => (this.isMobileAppSelectorOpen = value)),
      this.legalEntity.isModalOpen.subscribe((value) => (this.isModalOpen = value)),
      this.layout.version.subscribe((value) => (this.version = value)),
    );
    this.isCollapsed = false;
  }

  public toggleMobileMenu() {
    this.layout.isMobileMenuOpen.next(!this.isMobileMenuOpen);
    this.menu.menuItemSelectedId.next(-1);
  }

  isCollapsedSideNav(value) {
    this.isCollapsed = value;
    console.log(value, this.isCollapsed);
  }

  ngOnDestroy() {
    this.subsriptions.map((sub) => sub.unsubscribe());
  }
}
